<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-header">Все продукты</div>
					<div class="card-body">
						<p><router-link to="/events/create" class="btn btn-primary"><i class="fa fa-plus"></i> Создать продукт</router-link></p>
						<vuetable ref="vuetable"
							:fields="columns"
							:api-mode="false"
							:data="tableData"
							@vuetable:cell-dblclicked="rowClickHandler"
							class="table-striped">
							<template slot="email" slot-scope="props">
								<b-badge v-if="typeof props.rowData.email !== 'string'" variant="warning">нет</b-badge>
								<b-badge v-if="typeof props.rowData.email === 'string'" variant="success">есть</b-badge>
							</template>
							<template slot="actions" slot-scope="props">
								<b-dropdown variant="info" class="">
									<template slot="button-content"><i class="icon-settings"></i></template>
									<b-dropdown-item @click="actionEditHandler(props.rowData.id)"><i class="icon-pencil"></i>Редактировать</b-dropdown-item>
								</b-dropdown>
							</template>
						</vuetable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import productAPI from '@/api/modules/product/product'
export default {
	data: () => {
		return {
			columns: [
				{
					name: 'id',
					title: 'ID'
				}, {
					name: 'title',
					title: 'Заголовок'
				}, {
					name: 'description',
					title: 'Описание'
				}, {
					name: '__slot:email',
					title: 'Шаблон email-письма'
				}, {
					name: '__slot:actions',
					title: 'Действия'
				}
			],
			options: {},
			tableData: []
		}
	},
	mounted: function () {
		this.getProducts()
	},
	methods: {
		getProducts: function () {
			let params = {
				type_id: 6
			}
			productAPI.findAll(params).then((response) => {
				this.tableData = response
			}, function (response) {
			})
		},
		rowClickHandler (dataItem, field, event) {
			this.$router.push({path: `/product/${dataItem.id}/view`})
		},
		actionEditHandler (id) {
			this.$router.push({path: `/product/${id}/update`})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/product/index.vue